<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Withdrawal Requests</h4>
        <div class="text-muted small">Monitor and manage withdrawal operations</div>
      </div>

      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="loadRequests()">
        Refresh
      </button>
    </div>

    <form [formGroup]="filterForm" class="card shadow-sm border-0 mb-3">
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-3">
            <label class="form-label">Status</label>
            <select class="form-select" formControlName="status">
              <option value="">All</option>
              <option *ngFor="let item of statusOptions" [value]="item">{{ item }}</option>
            </select>
          </div>

          <div class="col-md-2">
            <label class="form-label">Currency</label>
            <input type="text" class="form-control" formControlName="currencyCode" placeholder="NGN" />
          </div>

          <div class="col-md-3">
            <label class="form-label">External Ref</label>
            <input type="text" class="form-control" formControlName="externalReference" placeholder="Search by ref" />
          </div>

          <div class="col-md-2">
            <label class="form-label">Gateway Ref</label>
            <input type="text" class="form-control" formControlName="gatewayReference" placeholder="Gateway ref" />
          </div>

          <div class="col-md-2">
            <label class="form-label">User Id</label>
            <input type="text" class="form-control" formControlName="userId" placeholder="User id" />
          </div>

          <div class="col-12">
            <button class="btn btn-primary" type="button" (click)="loadRequests()">
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </form>

    <div class="card shadow-sm border-0">
      <div class="card-body">
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm me-2"></div>
          Loading withdrawal requests...
        </div>

        <div class="table-responsive" *ngIf="!loading">
          <table class="table align-middle">
            <thead>
              <tr>
                <th>Date</th>
                <th>User</th>
                <th>Currency</th>
                <th>Amount</th>
                <th>Status</th>
                <th>External Ref</th>
                <th>Gateway Ref</th>
                <th>Method</th>
                <th>Failure</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of requests">
                <td>{{ item.createdAt | date:'medium' }}</td>
                <td class="small">{{ item.userId }}</td>
                <td>{{ item.currency.code }}</td>
                <td>{{ item.amount | smartAmount:item.currency.symbol }}</td>
                <td>
                  <span class="badge rounded-pill" [ngClass]="badgeClass(item.status)">
                    {{ item.status }}
                  </span>
                </td>
                <td class="small">{{ item.externalReference }}</td>
                <td class="small">{{ item.gatewayReference || '-' }}</td>
                <td>{{ item.paymentMethod || '-' }}</td>
                <td class="small text-danger">{{ item.failureReason || '-' }}</td>
                <td class="text-end">
                  <div class="d-flex gap-2 justify-content-end">
                    <button
                        class="btn btn-outline-secondary btn-sm"
                        [routerLink]="['/admin/withdrawals/requests', item.withdrawalId]">
                        View
                    </button>
                    <button
                      *ngIf="canComplete(item)"
                      class="btn btn-outline-success btn-sm"
                      type="button"
                      (click)="openCompleteModal(item)">
                      Complete
                    </button>

                    <button
                      *ngIf="canFail(item)"
                      class="btn btn-outline-danger btn-sm"
                      type="button"
                      (click)="openFailModal(item)">
                      Fail
                    </button>

                    <button
                      *ngIf="canRetry(item)"
                      class="btn btn-outline-primary btn-sm"
                      type="button"
                      (click)="retryRequest(item)">
                      Retry
                    </button>
                  </div>
                </td>
              </tr>

              <tr *ngIf="!requests.length">
                <td colspan="10" class="text-center text-muted py-4">
                  No withdrawal requests found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Complete Modal -->
    <div
      class="modal fade show"
      tabindex="-1"
      [ngStyle]="{ display: showCompleteModal ? 'block' : 'none' }"
      [class.d-block]="showCompleteModal"
      *ngIf="showCompleteModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow">
          <div class="modal-header">
            <h5 class="modal-title">Complete Withdrawal</h5>
            <button type="button" class="btn-close" (click)="closeModals()"></button>
          </div>

          <form [formGroup]="actionForm" (ngSubmit)="completeRequest()">
            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label">Gateway Reference</label>
                <input type="text" class="form-control" formControlName="gatewayReference" />
              </div>

              <div class="mb-3">
                <label class="form-label">Provider Response JSON</label>
                <textarea class="form-control" rows="4" formControlName="providerResponseJson"></textarea>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-outline-secondary" type="button" (click)="closeModals()">
                Cancel
              </button>

              <button class="btn btn-success" type="submit" [disabled]="actionLoading">
                <span *ngIf="actionLoading" class="spinner-border spinner-border-sm me-2"></span>
                Confirm Complete
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Fail Modal -->
    <div
      class="modal fade show"
      tabindex="-1"
      [ngStyle]="{ display: showFailModal ? 'block' : 'none' }"
      [class.d-block]="showFailModal"
      *ngIf="showFailModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow">
          <div class="modal-header">
            <h5 class="modal-title">Fail Withdrawal</h5>
            <button type="button" class="btn-close" (click)="closeModals()"></button>
          </div>

          <form [formGroup]="actionForm" (ngSubmit)="failRequest()">
            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label">Failure Reason</label>
                <textarea class="form-control" rows="4" formControlName="failureReason"></textarea>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-outline-secondary" type="button" (click)="closeModals()">
                Cancel
              </button>

              <button class="btn btn-danger" type="submit" [disabled]="actionLoading">
                <span *ngIf="actionLoading" class="spinner-border spinner-border-sm me-2"></span>
                Confirm Fail
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade show" *ngIf="showCompleteModal || showFailModal"></div>

    <app-footer></app-footer>
  </main>
</div>